import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS } from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";

function TypeSelector(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);
  
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  console.log('compContext.curView()',toJS(compContext.curView()));

  return (
    <div>
      <div className={`up12 splice`}>
        <div className={`cell s-shrink padd10 tac pointer ${compContext.cur_type_view === "elements"?"bg-w2":""}`} onClick={()=>{
          runInAction(()=>{
            compContext.cur_type_view="elements";
          });
        }}>
          Элементы
        </div>
        <div className={`cell s-shrink padd10 tac pointer ${compContext.cur_type_view === "sections"?"bg-w2":""}`} onClick={()=>{
            runInAction(()=>{
              compContext.cur_type_view="sections";
            });
          }}>
            Секции
        </div>
      </div>
    </div>
  )
};

TypeSelector.defaultProps = {};

TypeSelector.propTypes = {}

export default observer(TypeSelector);
